/** A command sent from the client to the server. */
export enum ClientCommand {
  chat = "chat",
  chatPM = "chatPM",
}
